import React, { Component } from 'react';
import CSSModules from 'react-css-modules'
import {
  ScreenedCompanies,
  ScrollToTop,
} from '../../components'
import Styles from './FossilFuelCompaniesContent.css'


@CSSModules(Styles)
export default class FossilFuelCompaniesContent extends Component {
  render() {
    return <section styleName='methodology-section'>
      <div styleName='anchor' id='companies'/>
      <h2 styleName='section-title'>
        Fossil fuel companies
      </h2>
      <h3 styleName='answer-title'>
        Tracking fossil fuel stocks
      </h3>
      <div styleName='answer-info'>
        <p>
          Our analysis checks funds for direct stock investments in fossil fuel companies. This list includes several sub-categories:
          top owners of carbon reserves, coal industry, oil/gas industry,
          top coal-fired utilities, and fossil-fired utilities.
        </p>
        <p>
          Two of these sub-categories are considered <b>higher risk</b>:
          top owners of carbon reserves, and top coal-fired utilities.
          Investment in these companies automatically earns a fund a
          fossil fuel grade of C or lower.
        </p>
        <ScreenedCompanies />
      </div>
      <ScrollToTop />
    </section>
  }
}
